import { createBrowserRouter, RouterProvider } from "react-router-dom";

// Import Layout
import MainLayout from "./layouts/MainLayout";

// Import Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Booking from "./pages/Booking";
import MenuPage from "./pages/Menu";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";

// Định nghĩa danh sách các Routes
const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />, // Layout bao bọc bên ngoài
    errorElement: <NotFound />, // Trang lỗi nếu nhập sai URL
    children: [
      {
        path: "home",
        element: <Home />,
      },      {
        index: true, // Đây là trang mặc định khi vào "/"
        element: <Home />,
      },
      {
        path: "kontakt",
        element: <Contact />,
      },   {
        path: "speisekarte",
        element: <MenuPage />,
      },
      {
        path: "tisch-reservieren",
        element: <Booking />,
      },
      {
        path: "/Impressum",
        element: <Impressum />,
      },
      {
        path: "/Datenschutz",
        element: <Datenschutz />,
      },
    ],
  },
  // Nếu bạn muốn có một trang Login KHÔNG có Header/Footer
  // Bạn có thể thêm một object mới ở đây, nằm ngoài MainLayout
  /*
  {
    path: "/login",
    element: <LoginPage />
  }
  */
]);

export default function App() {
  return <RouterProvider router={router} />;
}